<template>
   <div class="system">
       <breadcrumb :breadcrumb="crumbList"></breadcrumb>
       <div class="message" v-if="total > 0">
           <div class="message_item" v-for="(item,index) in messageList" :key="index" @click="goDetails(item)">
               <el-badge  value="new" :hidden="item.is_read ? true : false" class="item">
                    <img src="../../assets/msg/msg_logo2.png" alt="">
               </el-badge>
               <div class="message_item_content">
                   <div class="message_item_content_title">{{item.title}}</div>
                   <div class="message_item_content_time">{{item.create_time}}</div>
               </div>
           </div>
       </div>
       <div class="system_box_pagination" v-if="total > 0">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :pager-count="9"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>
                <div class="system_box_pagination_right">
                    <div class="system_box_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                    <div class="system_box_pagination_right_input">
                        到第
                        <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                        页
                    </div>
                    <div class="system_box_pagination_right_btn">
                        <el-button size="small" @click="changeNumberInput">确定</el-button>
                    </div>
                </div>
            </div>
   </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb'
export default {
   data (){
       return {
           crumbList:[
               {name:'消息提醒',path:'/message'},
               {name:'交易通知',path:'/payMessage'}
           ],
           message:[],
           pageNumber:1,
           pageNumberInput:1,
           total:0,
           pageSize:10,
           lastPage:0
       }
   },
   components: {
       breadcrumb
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       goDetails(item){
           this.$router.push({path:'/orderDetails',query:{orderId:item.uuid}});
           this.$post('MessageRead',{id:item.id});
       },
       // 手动输入页码后确定
        changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return 
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getMessage();
        },
        //    切换页码
        handleCurrentChange(val){
            this.pageNumber = val;
            this.pageNumberInput = val;
            this.getMessage();
        },
       getMessage(){
           this.messageList = [];
           this.loading = true;
           this.$get('Message',{page_size:10,page_index:this.pageNumber,type:1})
            .then(data => {
                this.loading = false;
                this.messageList = data.data;
                this.total = data.total;
                this.lastPage = data.last_page;
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });;
       }
   },
   created() {
       
   },
   mounted() {
       this.getMessage();
   }
}
</script>

<style scoped lang='less'>
.system{

    position: relative;
    .system_box_pagination{
        padding-top:30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#000000;
        /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
            min-width: 36px;
            height: 36px;
            padding-top:4px;
            margin: 0 4px;
        }
        /deep/ .btn-prev{
            margin-left: 0;
        }
        &_right{
            display: flex;
            align-items: baseline;
            &_num{
                span{
                    color:#3D7FFF;
                }
                
            }
            &_input{
                margin:0 10px;
            }
            &_btn{
                /deep/ .el-button{
                    background:#F0F2F5;
                    height: 36px;
                    border:1px solid #D7DBE0;
                    font-size: 14px;
                    color:#333;
                }
                /deep/ .el-button:hover{
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }
                
            }
        }
    }
}
.message{
    padding: 0 20px;

    &_item{
        height: 72px;
        display: flex;
        align-items: center;
        padding: 14px 0 10px 0;
        border-bottom:1px solid #EEEEEE;
        cursor: pointer;
        img{
            width:49px;
            height: 49px;
            
        }
        /deep/ .el-badge__content{
            right:16px;
            top:8px;
            line-height: 16px;
            background:#FF3B30;
        }
        &_content{
            margin-left:28px;
            &_title{
                font-size: 18px;
                color:#333;
            }
            &_time{
                font-size: 14px;
                color:#999999;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/message/payMessage.vue